"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = Banner;
const jsx_runtime_1 = require("react/jsx-runtime");
const icon_1 = require("./icon");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ A full-width notice above the shell — `AppShell`'s `banner` slot.          │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **NOT IN THE MOCKUP, SO THE DESIGN SYSTEM DECIDES IT, AND THE DECISION IS THE TRIAL CALLOUT.**
 * The billing page's *"Próbaidőszak — N nap van hátra"* is the one notice the mockup draws: a primary
 * hairline over a 5% primary wash. This is that, laid flat across the top as a single line —
 * `decisions.md` F-7.
 *
 * ⚠️ **`role="status"`, not `alert`**: it states a standing fact about the workspace rather than
 * interrupting anybody, and it is there on every page — an `alert` would be announced on each one.
 */
function Banner({ icon = 'sparkles', children, action }) {
    return ((0, jsx_runtime_1.jsxs)("div", { role: "status", "data-tour": "banner", className: "border-primary/20 bg-primary/5 flex shrink-0 items-center gap-2 border-b px-4 py-1.5 text-[12.5px]", children: [(0, jsx_runtime_1.jsx)(icon_1.Icon, { name: icon, size: 14, className: "text-primary shrink-0" }), (0, jsx_runtime_1.jsx)("div", { className: "min-w-0 flex-1", children: children }), action] }));
}
//# sourceMappingURL=banner.js.map